var Clubs = window.Clubs = window.Clubs || {}

Clubs.Calendar = {
  init: function() {
    $('td.event_day').hover(
      function() {
        $('li.event-row.' + 'date-' + $(this).attr('data-date')).css("background-color", "#F6F6F6");
      }, function() {
        $('li.event-row.' + 'date-' + $(this).attr('data-date')).css("background-color", "");
      }
    );
    $('.show_details').click(function() {
      $(this).closest('.event-row').find('.simple_event_details').toggle();
    });

    $('#simple_event_start_time').timepicker();
    $('#new-event-container .all_day').on('change', function() {
      if($(this).is(':checked')) {
        $('#simple_event_start_time').hide();
      } else {
        $('#simple_event_start_time').show();
      }
    });

    $('#event_start_time').timepicker();
    $('#event_end_time').timepicker();
    $('#plan-ride-container .all_day').on('change', function() {
      if($(this).is(':checked')) {
        $('#event_start_time').hide();
        $('#event_end_time').hide();
      } else {
        $('#event_start_time').show();
        $('#event_end_time').show();
      }
    });

    $('#plan-ride-container .auto_expire_participants').on('change', function() {
      if($(this).is(':checked')) {
        $('#participant_duration_options').show();
      } else {
        $('#participant_duration_options').hide();
      }
    });

    $('#club_calendar.can_edit td').on('click', function() {
      var dateYYMMDD = $(this).attr('data-date');
      $('.event_start_date').val(dateYYMMDD);
      rwgps.createEventModal()
    });
    $('.plan_simple_event').on('click', function() {
      $('#new-event-container').on('shown.bs.modal', function() {
        $('#simple_event_name').focus();
      });
    });
    $('.plan_ride_event').click(function() {
      $('#plan-ride-container').on('shown.bs.modal', function() {
        $('body').addClass('modal-open');
        $('#event_name').focus();
        $('#event_route_ids').val('');
      });
    });
  },
  load_month: function(club_id, year, month) {
    $.get('/clubs/' + club_id + '/calendar', {year: year, month: month}, function(response) {
      $('#event_calendar').html(response);
      Clubs.Calendar.init()
    });
  }
};



// WEBPACK FOOTER //
// ./public/javascripts/clubs/calendar.js